module.exports = __webpack_public_path__ + "img/hpfh.39de6b71.jpg";